import Vue from 'vue'

const state = {
  isSendingEmail: false
}

const actions = {
  SEND_EMAIL: ({commit}, contactData) => {
    commit('SET_IS_SENDING_EMAIL', true)
    Vue.http.post('send-business-email', contactData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_SENDING_EMAIL', false)
        if (!response.error) {
          console.log('success')
        }
      })
  },
  SEND_EMAIL_BIG_CLEANING: ({commit}, contactData) => {
    commit('SET_IS_SENDING_EMAIL', true)
    Vue.http.post('send-big-cleaning-email', contactData)
      .then(response => {
        return response.json()
      })
      .then(response => {
        commit('SET_IS_SENDING_EMAIL', false)
        if (!response.error) {
          console.log('success')
        }
      })
  }
}

const mutations = {
  SET_IS_SENDING_EMAIL: (state, status) => {
    state.isSendingEmail = status
  }
}

const getters = {
  getIsSendingEmail: state => {
    return state.isSendingEmail
  },
  isSending: state => {
    return state.isSendingEmail ? 'message.button.sending' : 'message.button.send'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/business.js